import { format } from 'date-fns';
import { motion } from 'framer-motion';

export default function ChatbotMessages({ messages, isLoading, messagesEndRef, phoneNumbers }) {
  const renderPhoneLinks = (text) => {
    if (!phoneNumbers.length) return text;
    const parts = text.split(/(\(\d{3}\) \d{3}-\d{4}|\d{3}-\d{3}-\d{4})/g);
    return parts.map((part, i) => {
      if (phoneNumbers.includes(part)) {
        const href = `tel:${part.replace(/[^+\d]/g, '')}`;
        return <a key={i} href={href} className="text-blue-600 underline">{part}</a>;
      }
      return <span key={i}>{part}</span>;
    });
  };

  return (
    <div className="flex-1 overflow-y-auto p-4 space-y-3 bg-gray-50">
      {messages.map((msg, i) => (
        <motion.div
          key={i}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          className={`flex ${msg.type === 'user' ? 'justify-end' : 'justify-start'}`}
        >
          <div className={`max-w-[75%] rounded-2xl px-4 py-2.5 shadow-sm ${msg.type === 'user' ? 'bg-blue-600 text-white' : 'bg-white text-gray-800 border'}`}>
            <p className="text-sm">{renderPhoneLinks(msg.text)}</p>
            <span className="text-xs opacity-70 block mt-1">
              {format(msg.timestamp, 'h:mm a')}
            </span>
          </div>
        </motion.div>
      ))}

      {isLoading && (
        <div className="flex gap-1">
          <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce"></div>
          <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
          <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
        </div>
      )}

      <div ref={messagesEndRef} />
    </div>
  );
}